// extracted by mini-css-extract-plugin
export var container = "_j8-0";
export var content = "_j8-3";
export var customerTitle = "_j8-4";
export var empty = "_j8-5";
export var gray = "_j8-6";
export var header = "_j8-7";
export var info = "_j8-8";
export var loading = "_j8-2";
export var loadingCard = "_j8-9";
export var oneLine = "_j8-a";
export var personName = "_j8-e";
export var pillContainer = "_j8-b";
export var selected = "_j8-1";
export var text = "_j8-c";
export var twoLines = "_j8-d";
export var unread = "_j8-f";
export var unreadIndicator = "_j8-g";